import { Injectable } from '@angular/core';
import {
  DwAction,
  DwActionHandler,
  DwActionResult,
  DwActionState,
  DwActionType,
  DwModalButtonStandardConfigs,
  DwModalConfig,
  DwModalService,
  DwModalSize
} from '@devwareapps/devware-cap';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AppPermissions } from '../../../meta-data/app-permissions.enum';
import { BunnyPlayerTestSettingsModalComponent } from '../components/bunny-player-test-settings-modal/bunny-player-test-settings-modal.component';

@DwAction({
  keyName: 'bunny-player-test-settings-action',
  display: 'Video Player Test Settings',
  actionType: DwActionType.menuAction,
  isGlobal: true,
  defaultButtonConfig: {
    useParentDisplay: false,
    buttonText: 'Video Player Test Settings',
    iconClass: 'fa fa-play-circle',
    buttonTitle: 'Choose the Bunny video player test mode'
  },
  defaultSecurityConfig: {
    requireAuthentication: true,
    useEmulatedPermissions: false,
    permissionMeaning: AppPermissions.lMSSetupAdmin
  }
})
@Injectable()
export class BunnyPlayerTestSettingsActionService implements DwActionHandler {
  constructor(private dwModalService: DwModalService) { }

  handleAction(_actionState: DwActionState<any>): Observable<DwActionResult> {
    const modalConfig = new DwModalConfig();
    modalConfig.buttons = DwModalButtonStandardConfigs.instance.okAndClose.map(button => ({ ...button }));
    modalConfig.buttons[0].buttonText = 'Save';
    modalConfig.allowFullScreen = false;
    modalConfig.modalSize = DwModalSize.responsive;
    modalConfig.component = BunnyPlayerTestSettingsModalComponent;
    modalConfig.title = 'Video Player Test Settings';

    return this.dwModalService.showModal(modalConfig).pipe(
      map(modalResult => {
        const result = new DwActionResult();
        result.cancelled = modalResult.cancelled;
        result.success = !modalResult.cancelled;
        return result;
      })
    );
  }
}
